import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';

import * as actions from '../../actions/ordersAction';
import * as symbols from '../../operations/symbols';
import { getBase64 } from '../../operations/operations';
import LoaderComponent from '../core/LoaderComponent';


class ConfirmationModal extends Component {

  constructor(props) {
    super(props);

    this.state = {}
  }

  handleImageInputClick(type) {
    document.getElementById(type).click((e) => {})
  }

  componentDidMount() {
    if (!this.props.orders.deliveryReasons)
      this.props.actions.getAllDeliveryIssueReasons('deliveryIssue');
  }

  goToReasonPage(id) {
    this.props.history.push(`/`)
  }

  renderReasonList() {
    const { orders } = this.props;
    return (
      <React.Fragment>
        We will inform the Hyperpure team that you will re-attempt the delivery of this order.
        {
          this.props.error && 
          <div className="red-text">{this.props.error ? this.props.error.message : null}</div>
        }
        {
          this.props.openLoader ? <LoaderComponent /> :
          <React.Fragment>
            <div className="btn btn-expand btn-red mt-2" onClick={this.props.cancelOrderDelivery}>Confirm Re-Attempt</div>
            <div className="btn btn-expand btn-transparent mt-1" onClick={this.props.closeConfirmationModal}>Go back</div>
          </React.Fragment>
        }
      </React.Fragment>
    )
  }

  render() {
    const { isOpen, status, orders } = this.props;
    if (isOpen) {
      return (
        <div className="modal">
          <div className="modal-overlay modal-picture">
            <div className="modal-title align-left">
              Re-Attempt Delivery
              <FontAwesomeIcon icon="times" className="right" onClick={this.props.closeConfirmationModal}/>
            </div>
            <div className="light-line" />
            {
              <div className="modal-body align-left">
                {this.renderReasonList()}
              </div>
            }
          </div>
        </div>
      )
    }
    return null
  }
}

export default withRouter(connect(
  state => ({
    errors: state.statuses.getDeliveryIssueReasons.errors,
    status: state.statuses.getDeliveryIssueReasons.status,
    orders: state.orders
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(ConfirmationModal));
